{
  "statementTransitions": {
    "fail": "Échec",
    "reconcile": "Rapprocher"
  },
  "viewStatement": "Afficher le relevé",
  "table": {
    "client": "Client",
    "organization": "Organisation",
    "account": "Compte",
    "statementState": "Nom de relevé",
    "statementType": "Type de relevé",
    "actions": "Actions"
  },
  "transitionStatements": {
    "title": "Relevés de transition",
    "bodyText": "Cela va faire passer {{totalCount}} déclarations à l'état RAPPROCHÉ. Cette action ne peut pas être annulée. Voulez-vous continuer ?",
    "transitionStatementsButton": "Transition",
    "clearSelectionButton": "Effacer la sélection",
    "totalCount": "Tous les {{totalCount}} relevés sélectionnés",
    "selectAll": "Sélectionner tous les {{totalCount}} relevés",
    "allRowsOnPageSelected": "Toutes les {{totalCount}} lignes de cette page ont été sélectionnées. Nombre total de lignes sélectionnées {{selectedCount}}",
    "rowsSelected": "{{selectedCount}} lignes sélectionnées"
  },
  "statementStates": {
    "AWAITING_REVIEW": "Examen en attente",
    "FAILED": "Échec",
    "RECONCILED": "Rapproché"
  },
  "statementTypes": {
    "OV_MONTHLY_ACCOUNT_STATEMENTS": "Relevés mensuels de compte OneVest",
    "ANNUAL_PERFORMANCE_REPORT": "Rapport annuel de performance",
    "ANNUAL_ACCOUNT_STATEMENTS": "Relevés de compte annuels",
    "QUARTERLY_ACCOUNT_STATEMENTS": "Relevés de compte trimestriels",
    "MONTHLY_ACCOUNT_STATEMENTS": "Relevés de compte mensuels",
    "CONSOLIDATED_MONTHLY_ACCOUNT_STATEMENTS": "Relevé de compte mensuel consolidé",
    "TAX_SLIPS_1099R": "Feuilles fiscales 1099R",
    "TAX_SLIPS_LAST_10_MONTHS": "Relevés fiscaux des 10 derniers mois",
    "TAX_SLIPS_FIRST_60_DAYS": "Relevés fiscaux des 60 premiers jours",
    "TAX_SLIPS_T4RSP_RL2": "Feuillets d'impôt T4RSP RL2",
    "TAX_SLIPS_T4RIF_RL2": "Feuilles de renseignements fiscaux T4RIF RL2",
    "TAX_SLIPS_T4A_RL1": "Feuillets d'impôt T4A RL1",
    "TAX_SLIPS_NR4": "Feuillets de déclaration fiscale NR4",
    "TAX_SLIPS_T5008": "Feuillets de renseignements fiscaux T5008",
    "TAX_SLIPS_TRADING_SUMMARY": "Résumé des opérations sur les relevés fiscaux",
    "TAX_SLIPS_T5_RL3": "Feuillets de renseignements fiscaux T5 RL3",
    "TAX_SLIPS_T3_RL16": "Feuillets de renseignements fiscaux T3 RL16",
    "TAX_SLIPS_T3_BREAKDOWN": "Détail des feuillets fiscaux T3",
    "TAX_SLIPS_T5013_RL15": "Feuillets de renseignements fiscaux T5013 RL15",
    "MANAGEMENT_FEES_ANNUAL_REPORT": "Rapport annuel sur les frais de gestion",
    "ADMINISTRATIVE_FEES_ANNUAL_REPORT": "Rapport annuel sur les frais administratifs",
    "TAX_SLIP_GENERAL": "Relevé fiscal général",
    "TRADE_CONFIRMATION": "Confirmations d'opération",
    "TAX_SLIPS_CONSOLIDATED_1099": "Relevés fiscaux consolidés 1099",
    "TAX_SLIPS_FORM_1042_S": "Formulaire 1042 S - Relevés fiscaux",
    "TAX_SLIPS_FORM_1099_Q": "Formulaire fiscal 1099 Q",
    "TAX_SLIPS_FORM_1099_R": "Formulaire fiscal 1099 R",
    "TAX_SLIPS_FORM_2439": "Formulaire fiscal 2439",
    "TAX_SLIPS_FORM_480_6A": "Formulaire fiscal 480 6A",
    "TAX_SLIPS_FORM_480_6B": "Formulaire fiscal 480 6B",
    "TAX_SLIPS_FORM_5498": "Formulaire fiscal 5498",
    "TAX_SLIPS_T4_FHSA": "Formulaire fiscal T4 FHSA"
  }
}
